import React, { useState } from 'react';
import Papa from 'papaparse';
import "../styles/FilterAndDownload.css"

const FilterAndDownload = () => {
  const [data, setData] = useState([]);
  
  const fetchData = async (collection) => {
    try {
      const response = await fetch(`http://localhost:8000/api/data?collection=${collection}`);
      
      // Check if the response is successful (status code 200)
      if (!response.ok) {
        throw new Error(`Server error: ${response.status}`);
      }
      
      // Get response as text (since it's a CSV)
      const textResponse = await response.text();
      console.log("Raw Response:", textResponse);
  
      // Check if response is empty
      if (!textResponse) {
        console.error("No data received.");
        return;
      }
  
      // Convert CSV to JSON (if needed)
      const results = Papa.parse(textResponse, { header: true });
      if (results.errors.length > 0) {
        console.error("Error parsing CSV:", results.errors);
        return;
      }
  
      setData(results.data);  // Assuming you want to store parsed data in state
  
    } catch (error) {
      console.error('Error retrieving data:', error);
      alert('There was an issue retrieving the data. Please try again later.');
    }
  };
  
  
  
  
  

  const downloadCSV = () => {
    try {
      // Check if there is data before generating the CSV
      if (data.length === 0) {
        console.error('No data available to generate CSV.');
        return;
      }

      const csv = Papa.unparse(data); // Using PapaParse to parse data to CSV format
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', 'data.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error generating CSV:', error);
    }
  };

  return (
    <div className="filter-container">
      <label className="select-label">Select Collection</label>
      <select 
        className="collection-select" 
        onChange={(e) => fetchData(e.target.value)}
      >
        <option value="">Select Collection</option>
        <option value="users">Users</option>
        <option value='Questions'>Questions</option>
        <option value='Results'>Results</option>
      </select>
      
      <button 
        className="download-button"
        onClick={downloadCSV}
        disabled={data.length === 0}
      >
        Download CSV
      </button>
    </div>
  );
};

export default FilterAndDownload;
